<template>
  <div class="zj-emergency-task-feedback-list select-none">
    <el-table :data="tableData" :show-header="false" stripe="false">
      <el-table-column>
        <template slot-scope="scope">
          <div class="task-row select-none">
            <div>
              <div>{{ convertDate(scope.row.CreateTime) }}</div>
              <div>{{ scope.row.Charger }}</div>
              <div :class="{islive:scope.row.FeedType == 2 }">【{{ convertSource(scope.row) }}】</div>
            </div>
            <!-- <div>{{scope.row.TaskTiltle + "\n\t"+ scope.row.FeedbackDesc}}</div> -->
            <div>{{scope.row.FeedbackDesc}}</div>
            <div v-if="scope.row.FeedAttachList && scope.row.FeedAttachList.length > 0">
              <div
                class="media-wrapper"
                v-for="item in scope.row.FeedAttachList"
                :key="item.AttachId"
              >
                <video v-if="isVideo(item.FileType)" controls>
                  <source v-bind:src="item.FileUrl" type="video/mp4" />
                  <source v-bind:src="item.FileUrl" type="video/ogg" />Your browser does not support the video tag.
                </video>
                <img v-else-if="isImage(item.FileType)" v-bind:src="item.FileUrl" alt="图片链接无效" />
                <div v-else>不支持的文件类型 {{item.FileType}}</div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import ZJApp from "../../../../../../app";
import Constant from "../config/constant";
import MyApis from "../../../../apis";

export default {
  name: "ZJEmergencyComponentTaskFeedbackList",
  componentName: "ZJEmergencyComponentTaskFeedbackList",
  components: {},
  props: {
    ExecutId: {
      type: String,
      required: true
    },
    planId: {
      type: String,
      required: true
    },
    planName: {
      type: String,
      required: true,
      default: "备用应急预案"
    },
    query: {
      obj: String,
      type: String
    }
  },
  data() {
    return {
      activeName: "first",
      tableData: [],
      dateFormat: "MM-dd hh:mm",
      msgkey: {
        emergencyFeedbackKey: "MessageKey_EmergencyFeedBack" + this.ExecutId
      }
    };
  },
  created() {
    this.$notify.subscript(this.msgkey.emergencyFeedbackKey, x =>
      this.onEmergencyFeedbackReceived(x)
    );
    console.log("subscript :" + this.msgkey.emergencyFeedbackKey);
    this.search();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    search() {
      let that = this;

      console.log(that.ExecutId);
      new MyApis.ExecutFeedbackApi()
        .FindByConditions({ ExecutId: that.ExecutId })
        .then(r => {
          r = r.data.Data;
          this.tableData = r;
        })
        .catch(e => {
          that.$message({
            message: e.RspMsg ? e.RspMsg : "加载反馈列表异常！",
            type: "error"
          });
        });
    },
    // statusClass: function(row) {
    //   return {
    //     processing: row.status == "未完成",
    //     todo: row.status == "待执行",
    //     finished: row.status == "已完成"
    //   };
    // },

    statusClass: function(row) {
      return {
        processing:
          row.TaskStatus == Constant.TaskStatus.Processing.desc ||
          row.TaskStatus == Constant.TaskStatus.Processing.code ||
          row.TaskStatus == Constant.TaskStatus.Exception.desc ||
          row.TaskStatus == Constant.TaskStatus.Exception.code ,
        todo:
          row.TaskStatus == Constant.TaskStatus.Todo.desc ||
          row.TaskStatus == Constant.TaskStatus.Todo.code,
        finished:
          row.TaskStatus == Constant.TaskStatus.Done.desc ||
          row.TaskStatus == Constant.TaskStatus.Done.code ||
          row.TaskStatus == Constant.TaskStatus.Closed.desc ||
          row.TaskStatus == Constant.TaskStatus.Closed.code
      };
    },
    convertDate: function(data) {
      return new Date(Date.parse(data)).format(this.dateFormat);
    },
    convertSource: function(row) {
      //反馈类型(1-事件反馈2-事态上报)
      return row.FeedType == 2
        ? "现场反馈"
        : row.ExecStatus
        ? "任务-" + this.getExecStatus(row.ExecStatus)
        : "";
    },
    getExecStatus(code) {
      var status = "";
      switch (code) {
        case Constant.TaskStatus.Todo.code:
        case Constant.TaskStatus.Todo.desc:
          status = Constant.TaskStatus.Todo.desc;
          break;
        case Constant.TaskStatus.Processing.code:
        case Constant.TaskStatus.Processing.desc:
          status = Constant.TaskStatus.Processing.desc;
          break;
        case Constant.TaskStatus.Done.code:
        case Constant.TaskStatus.Done.desc:
          status = Constant.TaskStatus.Done.desc;
          break;
        case Constant.TaskStatus.Closed.code:
        case Constant.TaskStatus.Closed.desc:
          status = Constant.TaskStatus.Closed.desc;
          break;
        case Constant.TaskStatus.Exception.code:
        case Constant.TaskStatus.Exception.desc:
          status = Constant.TaskStatus.Exception.desc;
          break;
        default:
          break;
      }
      return status;
    },
    onEmergencyFeedbackReceived: function(msg) {
      var record = JSON.parse(msg.firstBlock().text);
      this.tableData.unshift(record);
    },
    isImage: function(filename) {
      return ZJApp.ZJUtils.isImage(filename);
    },
    isVideo: function(filename) {
      return ZJApp.ZJUtils.isVideo(filename);
    }
  },
  watch: {}
};
</script>